/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'

import { ActionButton } from './ActionButton'

const MUTATION_WORKFLOWRUN = gql`
  mutation initiateWorkflowRun($input: WorkflowRunMutationInput!) {
    workflowrunMutate(input: $input) {
      workflowrun {
        id
      }
    }
  }
`


export const WorkflowInitiateButton = ({ requestRun, disabled, onInitiateClick, initiateInProgress }) => {
  const { requesttype, version, identity } = requestRun
  return (
    <Mutation mutation={MUTATION_WORKFLOWRUN}>
      {workflowrunMutate => (
        <ActionButton
          id='initiateRequestWorkflow'
          iconSymbol='flow'
          disabled={disabled}
          onClick={() => onInitiateClick(requesttype.workflow.id, version, requesttype.name, identity.fullName, workflowrunMutate)}>
          {initiateInProgress
            ? 'Initiating...'
            : 'Initiate workflow'
          }
        </ActionButton>
      )}
    </Mutation>
  )
}

WorkflowInitiateButton.propTypes = {
  requestRun: PropTypes.shape({
    version: PropTypes.number.isRequired,
    identity: PropTypes.shape({
      fullName: PropTypes.string.isRequired
    }),
    requesttype: PropTypes.shape({
      name: PropTypes.string.isRequired,
      workflow: PropTypes.shape({
        id: PropTypes.string.isRequired
      }).isRequired
    })
  }).isRequired,
  initiateInProgress: PropTypes.bool,
  disabled: PropTypes.bool,
  onInitiateClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/request-processing-sidebar/WorkflowInitiateButton.js